

var addChangeListener = function(callback) {
  this._changeListeners.push(callback);
};

var removeChangeListener = function(callback) {
  for (var i = 0; i < this._changeListeners.length; i++) {
    if (this._changeListeners[i] == callback) {
      this._changeListeners.splice(i, 1);
      break;
    }
  }
};

var notifyChangeListeners = function() {
  for (var i = 0; i < this._changeListeners.length; i++) {
    this._changeListeners[i]();
  }
};


var Feeds = {};

/**
 * Utility/Helper to add the "change listener" functionality used across a
 * number of feed services on the site.
 */
Feeds.ChangeListener = function(apiObject) {
  apiObject._changeListeners = [];
  apiObject.addChangeListener = addChangeListener;
  apiObject.removeChangeListener = removeChangeListener;
  apiObject.notifyChangeListeners = notifyChangeListeners;
};


export default Feeds;

